import React, { CSSProperties, ReactElement, ReactNode } from 'react'
import styled from 'styled-components'

const Styles = styled.div`
  &:first-child {
    margin-top: 13px;
  }
  margin-bottom: 13px;
`
export interface ILinkSectionProps {
  children: ReactNode
  style?: CSSProperties
}
export default function LinkSection(props: ILinkSectionProps): ReactElement {
  const { children, style } = props
  return <Styles style={style}>{children}</Styles>
}
